import { render, staticRenderFns } from "./PopUpCreacionIndicadorManual.vue?vue&type=template&id=24ec79a4&scoped=true"
import script from "./PopUpCreacionIndicadorManual.vue?vue&type=script&lang=js"
export * from "./PopUpCreacionIndicadorManual.vue?vue&type=script&lang=js"
import style0 from "./PopUpCreacionIndicadorManual.vue?vue&type=style&index=0&id=24ec79a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ec79a4",
  null
  
)

export default component.exports